import { render, staticRenderFns } from "./Annot8Canvas.vue?vue&type=template&id=12a595bc&"
import script from "./Annot8Canvas.vue?vue&type=script&lang=js&"
export * from "./Annot8Canvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports